/* France & Son PDP copy and spacing guard.
 *
 * Product apps hydrate after the theme. This intentionally observes only the
 * product purchase area for a short startup window, so the final buyer-facing
 * copy is present without a permanent whole-page observer or layout shift.
 */
(function () {
  'use strict';

  var quoteLabel = 'Request a Trade Quote / Swatch';
  var roomLabel = 'Design Around This Piece';
  var roomDetail = 'Discover furniture, lighting, décor, and art that work beautifully together.';
  var scheduled = false;
  var observer;
  var recommendationFallbackTimer;

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function setText(element, value) {
    if (element && textOf(element) !== value) element.textContent = value;
  }

  function applyCopy(scope) {
    var quoteReserve = scope.querySelector('[data-fs-quote-reserve]');
    var translatedQuoteLabel = textOf(quoteReserve) || quoteLabel;
    scope.querySelectorAll('.storeify-quote-btn-trigger-popup').forEach(function (button) {
      setText(button, translatedQuoteLabel);
      button.setAttribute('aria-label', translatedQuoteLabel);
    });

    scope.querySelectorAll('[data-ais-product-room-entry]').forEach(function (entry) {
      var button = entry.querySelector('.ais-product-room-btn');
      var label = entry.querySelector('.ais-product-room-btn-label');
      var detail = entry.querySelector('.ais-product-room-btn-detail');
      var productTitle = button && button.getAttribute('data-ais-product-title');

      setText(label, roomLabel);
      setText(detail, roomDetail);
      if (button) button.setAttribute('aria-label', roomLabel + (productTitle ? ': ' + productTitle : ''));
    });
  }

  function bindQuoteFallback(scope) {
    scope.querySelectorAll('[data-fs-quote-reserve]').forEach(function (fallback) {
      if (fallback.dataset.fsQuoteBound === 'true') return;
      fallback.dataset.fsQuoteBound = 'true';

      fallback.addEventListener('click', function () {
        var form = fallback.closest('.product-single__form');
        if (!form) return;

        var tries = 0;
        var activate = function () {
          var quoteButton = form.querySelector('.ify-quote-group .storeify-quote-btn-trigger-popup, .storeify-quote-btn-trigger-popup');
          if (quoteButton) {
            quoteButton.click();
            return true;
          }
          return false;
        };

        if (activate()) return;
        fallback.setAttribute('aria-busy', 'true');
        var timer = window.setInterval(function () {
          tries += 1;
          if (activate()) {
            window.clearInterval(timer);
            fallback.removeAttribute('aria-busy');
          } else if (tries >= 30) {
            window.clearInterval(timer);
            window.location.assign('/pages/contact-us-or-text-us?request=trade-quote');
          }
        }, 100);
      });
    });
  }

  function recommendationHasContent(discovery) {
    if (!discovery || !discovery.isConnected) return false;

    // The discovery app renders inside a shadow root. Do not use the host's
    // height as a readiness signal: our reserved loading height deliberately
    // makes an empty host tall enough to look "ready". Require actual product
    // content instead so an app failure always falls back to the native rail.
    var root = discovery.shadowRoot || discovery;
    var productLinks = root.querySelectorAll('a[href*="/products/"]').length;
    var productRecords = root.querySelectorAll('[data-product-id], [data-product-handle]').length;
    return productLinks > 0 || productRecords > 0;
  }

  function consolidateRecommendations() {
    var discovery = document.querySelector('ai-search-product-discovery[data-heading]');
    var nativeRail = document.querySelector('.fs-recommendation-rail');
    var nativeSection = nativeRail && nativeRail.closest('.shopify-section');
    if (!discovery || !nativeSection) return;

    if (discovery.dataset.fsRecommendationPrimary === 'true') {
      if (recommendationHasContent(discovery)) {
        discovery.classList.remove('fs-product-discovery--hydrating');
      }
      return;
    }

    // Put the app host in its final location before it hydrates so shoppers do
    // not see the native rail first and then watch the page swap underneath it.
    // The native rail stays in the DOM as a timed fail-open fallback.
    if (!nativeSection.parentNode) return;
    nativeSection.parentNode.insertBefore(discovery, nativeSection);
    discovery.dataset.fsRecommendationPrimary = 'true';
    discovery.classList.add('fs-product-discovery--primary', 'fs-product-discovery--hydrating');
    nativeSection.classList.remove('fs-recommendation-awaiting-app');
    nativeSection.removeAttribute('aria-busy');
    nativeSection.hidden = true;
    nativeSection.setAttribute('aria-hidden', 'true');
  }

  function primeRecommendations() {
    var nativeRail = document.querySelector('.fs-recommendation-rail');
    var nativeSection = nativeRail && nativeRail.closest('.shopify-section');
    if (!nativeSection || nativeSection.dataset.fsRecommendationPrimed === 'true') return;

    nativeSection.dataset.fsRecommendationPrimed = 'true';
    nativeSection.classList.add('fs-recommendation-awaiting-app');
    nativeSection.setAttribute('aria-busy', 'true');

    window.clearTimeout(recommendationFallbackTimer);
    recommendationFallbackTimer = window.setTimeout(function () {
      var discovery = document.querySelector('ai-search-product-discovery.fs-product-discovery--primary');
      if (recommendationHasContent(discovery)) {
        discovery.classList.remove('fs-product-discovery--hydrating');
        return;
      }

      if (discovery) {
        discovery.hidden = true;
        discovery.setAttribute('aria-hidden', 'true');
      }
      nativeSection.hidden = false;
      nativeSection.removeAttribute('aria-hidden');
      nativeSection.removeAttribute('aria-busy');
      nativeSection.classList.remove('fs-recommendation-awaiting-app');
    }, 10000);
  }


  var purchaseAppScopes = new WeakSet();

  function positionPurchaseApps(scope) {
    var title = scope.querySelector('.product-single__header .product-single__title');
    var bar = scope.querySelector('.swym-wishlist-button-bar');
    var availability = scope.querySelector('.product-single__form .fs-purchase-availability');
    var statusRow = scope.querySelector('.fs-product-status-row');
    if (availability || statusRow) {
      if (!statusRow) {
        statusRow = document.createElement('div');
        statusRow.className = 'fs-product-status-row';
        var details = document.createElement('div');
        details.className = 'fs-product-stock-details';
        availability.parentNode.insertBefore(statusRow, availability);
        statusRow.appendChild(details);
        details.appendChild(availability);
      }
      var stockDetails = statusRow.querySelector('.fs-product-stock-details');
      scope.querySelectorAll('.fs-product-app-slot--lead-time').forEach(function (leadTime) {
        if (leadTime.parentNode !== stockDetails) stockDetails.appendChild(leadTime);
      });
      var wishlistSlot = statusRow.querySelector('[data-fs-wishlist-slot]') || statusRow;
      if (bar && bar.parentNode !== wishlistSlot) wishlistSlot.appendChild(bar);
      if (bar) {
        bar.querySelectorAll('button').forEach(function (button) {
          button.setAttribute('type', 'button');
        });
      }
    } else if (title && bar && title.nextElementSibling !== bar) {
      title.insertAdjacentElement('afterend', bar);
    }
    scope.querySelectorAll('.fs-product-purchase-row .appstle_widget').forEach(function (widget) {
      var row = widget.closest('.fs-product-purchase-row');
      row.insertAdjacentElement('beforebegin', widget);
    });
    scope.querySelectorAll('.fs-product-purchase-row .ify-quote-group').forEach(function (group) {
      var form = group.closest('.product-single__form');
      var reserve = form && form.querySelector('[data-fs-quote-reserve]');
      if (reserve && reserve.parentNode === form) form.insertBefore(group, reserve);
    });
    scope.querySelectorAll('.fs-product-purchase-row [data-ais-product-room-entry]').forEach(function (entry) {
      var form = entry.closest('.product-single__form');
      var quote = form && form.querySelector('.ify-quote-group');
      if (quote) quote.insertAdjacentElement('afterend', entry);
      else if (form) form.insertAdjacentElement('afterend', entry);
    });
  }

  function watchPurchaseApps(scope) {
    if (purchaseAppScopes.has(scope)) return;
    purchaseAppScopes.add(scope);
    var purchaseAppObserver = new MutationObserver(function (records) {
      var injected = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('.swym-wishlist-button-bar, .swym-add-to-wishlist, .ify-quote-group, [data-ais-product-room-entry], .appstle_widget, .fs-product-app-slot--lead-time, .fs-purchase-availability') ||
            node.querySelector('.swym-wishlist-button-bar, .swym-add-to-wishlist, .ify-quote-group, [data-ais-product-room-entry], .appstle_widget, .fs-product-app-slot--lead-time, .fs-purchase-availability')
          );
        });
      });
      if (injected) positionPurchaseApps(scope);
    });
    purchaseAppObserver.observe(scope, { childList: true, subtree: true });
    positionPurchaseApps(scope);
  }

  function bindWishlistReserve(scope) {
    scope.querySelectorAll('[data-fs-wishlist-slot]').forEach(function (slot) {
      var reserve = slot.querySelector('[data-fs-wishlist-reserve]');
      var status = slot.querySelector('[data-fs-wishlist-status]');
      if (!reserve || slot.dataset.fsWishlistBound === 'true') return;
      slot.dataset.fsWishlistBound = 'true';
      var pending = false;
      var pendingVariant = '';
      var timeout;
      var variantSelect = slot.closest('form').querySelector('[name="id"]');

      function clearPending() {
        pending = false;
        window.clearTimeout(timeout);
        reserve.removeAttribute('aria-busy');
      }

      function sync() {
        var button = slot.querySelector('.swym-add-to-wishlist.swym-loaded');
        if (!button || button.disabled) return;
        button.setAttribute('type', 'button');
        if (!button.querySelector('.fs-wishlist-icon')) {
          button.appendChild(reserve.querySelector('svg').cloneNode(true));
        }
        if (!slot.classList.contains('fs-wishlist-ready')) {
          var hadFocus = document.activeElement === reserve;
          slot.classList.add('fs-wishlist-ready');
          status.hidden = true;
          if (hadFocus) button.focus({ preventScroll: true });
        }
        if (pending) {
          var sameVariant = !variantSelect || variantSelect.value === pendingVariant;
          clearPending();
          if (sameVariant) button.click();
        }
      }

      reserve.addEventListener('click', function () {
        if (pending) return;
        pending = true;
        pendingVariant = variantSelect ? variantSelect.value : '';
        reserve.setAttribute('aria-busy', 'true');
        status.textContent = reserve.dataset.loadingLabel;
        status.hidden = false;
        timeout = window.setTimeout(function () {
          clearPending();
          status.textContent = reserve.dataset.retryLabel;
        }, 30000);
        sync();
      });
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          clearPending();
          status.hidden = true;
        });
      }
      var wishlistObserver = new MutationObserver(sync);
      wishlistObserver.observe(slot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
      sync();
    });
  }

  function polish(scope) {
    applyCopy(scope);
    bindQuoteFallback(scope);
    consolidateRecommendations();
  }

  function queuePolish(scope) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      polish(scope);
    });
  }

  function start() {
    var scope = document.querySelector('.template-product .product-single__meta') || document.querySelector('.product-single__meta');
    if (!scope) return;

    if (observer) observer.disconnect();
    primeRecommendations();
    watchPurchaseApps(scope);
    bindWishlistReserve(scope);
    polish(scope);
    window.setTimeout(function () { polish(scope); }, 500);
    window.setTimeout(function () { polish(scope); }, 1500);
    window.setTimeout(function () { polish(scope); }, 3000);
    window.setTimeout(function () { polish(scope); }, 6000);
    window.setTimeout(function () { polish(scope); }, 9000);
    var currentObserver = new MutationObserver(function () { queuePolish(scope); });
    observer = currentObserver;
    currentObserver.observe(scope, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      currentObserver.disconnect();
      if (observer === currentObserver) observer = null;
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
}());

